import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import { MyThunkDispatch, RootState } from 'store';
import * as yup from 'yup';

//import { updateAccount } from 'actions/user';
import Header from 'components/AppBar';
/* import SubmitButton from 'components/Buttons/SubmitButton'; */
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useUserAccount from 'hooks/useUserAccount';
import useCompanyConfiguration from 'hooks/useCompanyConfiguration';
import { FieldArray } from 'formik';
import {
  Container,
  Wrapper,
  FormContainer,
  Field,
  CloseButton,
  CloseIcon,
  SearchButtonContainer,
  SearchButton,
} from './styles';
import { getCompanyConfiguration, getCompanyConfigurationByUpdate, updateCompanyConfiguration } from 'actions/companyConfiguration';
import ToggleCard from 'components/ToggleCard';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AddAndRemoveSector } from 'components/FlightsSearch/styles';
import useToast from 'hooks/useToast';
import CustomSelect, { RenderProps as CustomSelectRenderProps } from 'components/Selects/CustomSelect';
import OptionsItems from './OptionsItems';
import PaymentExceptions from './PaymentExceptions';
import FaviconPhotoInfo from 'components/FaviconPhotoInfo';
import { AvatarChange } from 'components/AvatarCrop';
import { getFavicon, getLogoCompanyImage, getLogoResellerImage, uploadFavicon, uploadLogoCompany, uploadLogoReseller } from 'services/photoFaviconService';
import { base64ToFile } from 'utils/generic';
import useIsMobile from 'hooks/useIsMobile';
import { updateCompanyPayment } from 'actions/companyPayment';
import LogoResellerPhoto from 'components/LogoResellerPhoto';
import LogoCompanyPhoto from 'components/LogoCompanyPhoto';

/* import { CompanyConfiguration } from 'models/company'; */

const CompanyConfigurationUpdate = () => {
  const history = useHistory();
  const isMobile = useIsMobile();
  const dispatch: MyThunkDispatch = useDispatch();
  const [loadConfigurationCompany, setLoadConfigurationCompany] = useState(false);
  const [myConfigurationCompany, setMyConfigurationCompany] = useState(useCompanyConfiguration());
  const accountResult = useSelector((state: RootState) => state.user.accountResult);
  const { t } = useStoreTranslation();
  const toast = useToast();
  const currencyCodeRef = useRef(null);
  const [currencyCodeSelected, setCurrencyCodeSelected] = useState('');
  const alternativeCurrencyCodeRef = useRef(null);
  const [alternativeCurrencyCodeSelected, setAlternativeCurrencyCodeSelected] = useState('');

  useEffect(() => {    
    const loadConfigCompany = async () => {
      const splitUrl = window.location.href.split('/companyConfigurationUpdate/');
      const cc = await getCompanyConfigurationByUpdate(accountResult.companyId);
      setMyConfigurationCompany(cc.data.data);
      setCurrencyCodeSelected(cc.data.data.currencyCode);
      setAlternativeCurrencyCodeSelected(cc.data.data.alternativeCurrencyCode);
      getCompanyFavicon();
      getLogoReseller();
      getLogoCompany();
    };


    loadConfigCompany();
  }, []);
  
  const account = useUserAccount();
  
  const handleSaveImageFavicon = useCallback(async (data: FormData) => {
    data.append('companyid', myConfigurationCompany?.companyId ?? '');
    await uploadFavicon(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveImageLogoReseller = useCallback(async (data: FormData) => {
    data.append('companyid', myConfigurationCompany?.companyId ?? '');
    await uploadLogoReseller(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  
  
  const handleSaveImageLogoCompany = useCallback(async (data: FormData) => {
    data.append('companyid', myConfigurationCompany?.companyId ?? '');
    await uploadLogoCompany(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  
  
  const handleSubmit = async (values: any) => {

    values.currencyCode = currencyCodeSelected;
    values.alternativeCurrencyCode = alternativeCurrencyCodeSelected;

    const result = await dispatch(updateCompanyConfiguration(values, accountResult.companyId));
    
    await updateCompanyPayment({
      lineOfCreditAvailable: values.lineOfCreditAvailable,
      creditCardByUser: values.creditCardByUser
    }, accountResult.companyId);

    if (result) {
      
      if (newPhotoFavicon) {        
        await handleSaveImageFavicon(newPhotoFavicon.formData);        
      }

      if (newPhotoLogoReseller) {        
        await handleSaveImageLogoReseller(newPhotoLogoReseller.formData);        
      }

      if (newPhotoLogoCompany) {        
        await handleSaveImageLogoCompany(newPhotoLogoCompany.formData);        
      }

      await dispatch(getCompanyConfiguration(accountResult.companyId));
      
      await toast.add({
        type: 'success',
        message: t('resellerForm.post.success'),
      });
      history.push('/corporate/configurations');
    }
  };

  const currencyCodeList = [
    { name: 'Seleccione la moneda', value: '' },
    { name: 'COP - Pesos colombianos', value: 'COP' },
    { name: 'BRL - Reales Brasil', value: 'BRL' },
    { name: 'ARS - Pesos argentinos', value: 'ARS' },
    { name: 'MXN - Pesos mexicanos', value: 'MXN' },
    { name: 'GTQ - Quetzales Guatemala', value: 'GTQ' },
    { name: 'CRC - Colon Costa Rica', value: 'CRC' },
    { name: 'HNL - Lempira Honduras', value: 'HNL' },
    { name: 'SVC - Colon Salvadoreño', value: 'SVC' },
    { name: 'NIO - Córdoba Nicaragüense', value: 'NIO' },
    { name: 'DOP - Peso República Dominicana', value: 'DOP' },
    { name: 'USD - Dólar americano', value: 'USD' },
    { name: 'EUR - Euro', value: 'EUR' },
    { name: 'GPB - Libras', value: 'GPB' },
    { name: 'CAD - Dólar canadiense', value: 'CAD' },
    { name: 'AUD - Dólar australiano', value: 'AUD' },
    { name: 'CLP - Pesos chilenos', value: 'CLP' },
    { name: 'UYU - Pesos uruguayos', value: 'UYU' },
    { name: 'PEN - Nuevo sol peruano', value: 'PEN' },
    { name: 'PYG - Guaraní Paraguay', value: 'PYG' },
    { name: 'BOB - Boliviano Bolivia', value: 'BOB' },
  ];

  const hideLogoAndColor = () => {
    if (account.type === 'supportImplementation') return false;

    if (!myConfigurationCompany?.menuView?.showLogoAndColors) return false;

    return true;
  };

  const validationSchema = yup.object().shape({
    companyId: yup.string(),
    currencyCode: yup.string(), //si
    alternativeCurrencyCode: yup.string(), //si
    apiBaseUrl: yup.string(), //si
    tokenexUrls: yup.string(),
    primaryBackgroundColor: yup.string(),
    primaryColor: yup.string(),
    secondaryBackgroundColor: yup.string(),
    secondaryColor: yup.string(),
    tertiaryBackgroundColor: yup.string(),
    tertiaryColor: yup.string(),
    imageLogo: yup.string(),
    companyName: yup.string(),
    email: yup.string(), //si
    phone: yup.string(), //si
    whatsapp: yup.string(), //si
    termsAndConditionsURL: yup.string(),
    privacyPoliciesURL: yup.string(),
    ownerCompanyName: yup.string(),
    ownerImageLogo: yup.string(),
    userService: yup.string(),
    usernameNetactica: yup.string(),
    userServiceNetacticaAlias: yup.string(),
    passwordNetactica: yup.string(),
    branchCodeNetactica: yup.string(), //si
    businessUnitNetactica: yup.string(), //si
    countryCode: yup.string(), //si
    companyDocumentNumberNetactica: yup.number(), //si
    profileDocumentNumberNetactica: yup.number(), //si
    passportDocumentNumberNetactica: yup.number(), //si
    emailFooter: yup.string(), //si
    emailFooterBackground: yup.string(),
    emailFooterColor: yup.string(),
    emailBodyTextColor: yup.string(),
    emailButtonColor: yup.string(),
    emailButtonText: yup.string(),
    twilioWhatsappNumberFrom: yup.string(), //si
    emailDisplayEmail: yup.string(), //si
    emailDisplayName: yup.string(), //si
    sendCopyVoucher: yup.string(), //si
    sendCopyApprovedMail: yup.string(),
    notSendVoucherOthersFlightPassenger: yup.boolean(), //si
    nationalAirBySector: yup.boolean(), //si
    internationalAirBySector: yup.boolean(), //si    
    script3CX: yup.string(),
    stylesPersonalization: yup.object().shape({
      javascriptUrl: yup.string(),
      cssUrl: yup.string(),
    }),
    menuView: yup.object().shape({
      useWhatsappSupport: yup.string(),
      useWhatsappSupportMessage: yup.string(),
      showWhatsappAllPages: yup.boolean(),
      hideAirFlow: yup.boolean(), //si
      hideHotelFlow: yup.boolean(), //si
      hideVehicleFlow: yup.boolean(), //si
      hideExpenses: yup.boolean(), //si
      hideWhatsapp: yup.boolean(), //si
      hideCostCenter: yup.boolean(), //si
      hideReports: yup.boolean(), //si
      hotelSearchV2: yup.boolean(),
      downloadExcelExpenses: yup.boolean(),
      showLogoAndColors: yup.boolean(),
      hideTravelReason: yup.boolean(),
    }),
    loginSso: yup.object().shape({
      nsLogin: yup.boolean(),
      isSsoCorporate: yup.boolean(),
      sso: yup.array().of(
        yup.object().shape({
          url: yup.string(),
          textButton: yup.string(),
          backgroundColor: yup.string(),
          textColor: yup.string(),
          logo: yup.string(),
        }),
      ),
    }),
    lineOfCreditAvailable: yup.boolean(),
    creditCardByUser: yup.boolean(),
    pageTitle: yup.string(),
    application: yup.string(),
    applicationUrl: yup.string(),
    documentation: yup.string(),
    documentationUrl: yup.string(),
  });

  const isValidCurrencyCode = () => {
    if (!currencyCodeSelected) {
      return 'Seleccione la moneda principal';
    }
  };

  const initValues = {
    companyId: myConfigurationCompany?.companyId || '',
    currencyCode: myConfigurationCompany?.currencyCode || '',
    alternativeCurrencyCode: myConfigurationCompany?.alternativeCurrencyCode || '',
    apiBaseUrl: myConfigurationCompany?.apiBaseUrl || '',
    tokenexUrls: myConfigurationCompany?.tokenexUrls || '',
    primaryBackgroundColor: myConfigurationCompany?.primaryBackgroundColor || '',
    primaryColor: myConfigurationCompany?.primaryColor || '',
    secondaryBackgroundColor: myConfigurationCompany?.secondaryBackgroundColor || '',
    secondaryColor: myConfigurationCompany?.secondaryColor || '',
    tertiaryBackgroundColor: myConfigurationCompany?.tertiaryBackgroundColor || '',
    tertiaryColor: myConfigurationCompany?.tertiaryColor || '',
    imageLogo: myConfigurationCompany?.imageLogo || '',
    companyName: myConfigurationCompany?.companyName || '',
    email: myConfigurationCompany?.email || '',
    phone: myConfigurationCompany?.phone || '',
    whatsapp: myConfigurationCompany?.whatsapp || '',
    termsAndConditionsURL: myConfigurationCompany?.termsAndConditionsURL || '',
    privacyPoliciesURL: myConfigurationCompany?.privacyPoliciesURL || '',
    ownerCompanyName: myConfigurationCompany?.ownerCompanyName || '',
    ownerImageLogo: myConfigurationCompany?.ownerImageLogo || '',
    userService: myConfigurationCompany?.userService || '',
    userServiceNetacticaAlias: myConfigurationCompany?.userServiceNetacticaAlias || '',
    usernameNetactica: myConfigurationCompany?.usernameNetactica || '',
    passwordNetactica: myConfigurationCompany?.passwordNetactica || '',
    branchCodeNetactica: myConfigurationCompany?.branchCodeNetactica || '',
    businessUnitNetactica: myConfigurationCompany?.businessUnitNetactica || '',
    countryCode: myConfigurationCompany?.countryCode || '',
    companyDocumentNumberNetactica: myConfigurationCompany?.companyDocumentNumberNetactica || 0,
    profileDocumentNumberNetactica: myConfigurationCompany?.profileDocumentNumberNetactica || 0,
    passportDocumentNumberNetactica: myConfigurationCompany?.passportDocumentNumberNetactica || 0,
    emailFooter: myConfigurationCompany?.emailFooter || '',
    emailFooterBackground: myConfigurationCompany?.emailFooterBackground || '',
    emailFooterColor: myConfigurationCompany?.emailFooterColor || '',
    emailBodyTextColor: myConfigurationCompany?.emailBodyTextColor || '',
    emailButtonColor: myConfigurationCompany?.emailButtonColor || '',
    emailButtonText: myConfigurationCompany?.emailButtonText || '',
    twilioWhatsappNumberFrom: myConfigurationCompany?.twilioWhatsappNumberFrom || '',
    emailDisplayEmail: myConfigurationCompany?.emailDisplayEmail || '',
    emailDisplayName: myConfigurationCompany?.emailDisplayName || '',
    sendCopyVoucher: myConfigurationCompany?.sendCopyVoucher || '',
    sendCopyApprovedMail: myConfigurationCompany?.sendCopyApprovedMail || '',
    notSendVoucherOthersFlightPassenger: myConfigurationCompany?.notSendVoucherOthersFlightPassenger || false,
    nationalAirBySector: myConfigurationCompany?.nationalAirBySector || false,
    internationalAirBySector: myConfigurationCompany?.internationalAirBySector || false,
    script3CX: myConfigurationCompany?.script3CX || '',
    stylesPersonalization: {
      javascriptUrl: myConfigurationCompany?.stylesPersonalization?.javascriptUrl || '',
      cssUrl: myConfigurationCompany?.stylesPersonalization?.cssUrl || '',
    },
    menuView: {
      hideAirFlow: myConfigurationCompany?.menuView?.hideAirFlow || false,
      hideHotelFlow: myConfigurationCompany?.menuView?.hideHotelFlow || false,
      hideVehicleFlow: myConfigurationCompany?.menuView?.hideVehicleFlow || false,
      hideExpenses: myConfigurationCompany?.menuView?.hideExpenses || false,
      hideWhatsapp: myConfigurationCompany?.menuView?.hideWhatsapp || false,
      hideCostCenter: myConfigurationCompany?.menuView?.hideCostCenter || false,
      hideReports: myConfigurationCompany?.menuView?.hideReports || false,
      hotelSearchV2: myConfigurationCompany?.menuView?.hotelSearchV2 || false,
      useWhatsappSupport: myConfigurationCompany?.menuView?.useWhatsappSupport || '',
      useWhatsappSupportMessage: myConfigurationCompany?.menuView?.useWhatsappSupportMessage || '',
      showWhatsappAllPages: myConfigurationCompany?.menuView?.showWhatsappAllPages || false,
      downloadExcelExpenses: myConfigurationCompany?.menuView?.downloadExcelExpenses || false,
      showLogoAndColors: myConfigurationCompany?.menuView?.showLogoAndColors || false,
      hideTravelReason: myConfigurationCompany?.menuView?.hideTravelReason || false,
    },
    loginSso: {
      nsLogin: myConfigurationCompany?.loginSso?.nsLogin || false,
      isSsoCorporate: myConfigurationCompany?.loginSso?.isSsoCorporate || false,
      sso: myConfigurationCompany?.loginSso?.sso || [],      
    },
    lineOfCreditAvailable: myConfigurationCompany?.lineOfCreditAvailable || false,
    creditCardByUser: myConfigurationCompany?.creditCardByUser || false,
    pageTitle: myConfigurationCompany?.pageTitle || '',
    application: myConfigurationCompany?.application || '',
    applicationUrl: myConfigurationCompany?.applicationUrl || '',
    documentation: myConfigurationCompany?.documentation || '',
    documentationUrl: myConfigurationCompany?.documentationUrl || '',
  };

  const [newPhotoFavicon, setNewPhotoFavicon] = useState<AvatarChange>();
  const [newPhotoLogoReseller, setNewPhotoLogoReseller] = useState<AvatarChange>();
  const [newPhotoLogoCompany, setNewPhotoLogoCompany] = useState<AvatarChange>();
  
  const handleChangePhoto = (val: AvatarChange) => {
    setNewPhotoFavicon(val);
  };

  const handleChangePhotoLogoReseller = (val: AvatarChange) => {
    setNewPhotoLogoReseller(val);
  };

  const handleChangePhotoLogoCompany = (val: AvatarChange) => {
    setNewPhotoLogoCompany(val);
  };
  
  const [srcFavicon, setSrcFavicon] = useState<string>();
  const getCompanyFavicon = useCallback(
    async () => {
      try {

        try {
          
          const responsePhoto = await getFavicon(myConfigurationCompany?.companyId);

          if (responsePhoto.succeeded && responsePhoto.data.picture) {
            const file = await base64ToFile(
              `data:text/plain;base64,${responsePhoto.data.picture}` as string,
              responsePhoto.data.extension,
            );

            const reader = new FileReader();
            reader.readAsDataURL(file as File);

            reader.onload = () => {
              setSrcFavicon(reader.result as string);
            };
          } else if (responsePhoto.succeeded && responsePhoto.data.url) {
            setSrcFavicon(responsePhoto.data.url as string);
          }
        } catch (e) {}
      } catch (error) { } 
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const [srcLogoReseller, setSrcLogoReseller] = useState<string>();
  const getLogoReseller = useCallback(
    async () => {
      try {

        try {
          
          const responsePhoto = await getLogoResellerImage(myConfigurationCompany?.companyId);

          if (responsePhoto.succeeded && responsePhoto.data.picture) {

            const file = await base64ToFile(
              `data:text/plain;base64,${responsePhoto.data.picture}` as string,
              responsePhoto.data.extension,
            );

            const reader = new FileReader();
            reader.readAsDataURL(file as File);

            reader.onload = () => {
              setSrcLogoReseller(reader.result as string);
            };
          } else if (responsePhoto.succeeded && responsePhoto.data.url) {
            setSrcLogoReseller(responsePhoto.data.url as string);
          }
        } catch (e) {}
      } catch (error) { } 
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const [srcLogoCompany, setSrcLogoCompany] = useState<string>();
  const getLogoCompany = useCallback(
    async () => {
      try {

        try {
          
          const responsePhoto = await getLogoCompanyImage(myConfigurationCompany?.companyId);

          if (responsePhoto.succeeded && responsePhoto.data.picture) {

            const file = await base64ToFile(
              `data:text/plain;base64,${responsePhoto.data.picture}` as string,
              responsePhoto.data.extension,
            );

            const reader = new FileReader();
            reader.readAsDataURL(file as File);

            reader.onload = () => {
              setSrcLogoCompany(reader.result as string);
            };
          } else if (responsePhoto.succeeded && responsePhoto.data.url) {
            setSrcLogoCompany(responsePhoto.data.url as string);
          }
        } catch (e) {}
      } catch (error) { } 
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  
  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/configurations')}>Configuración General</Header>
        </Mobile>

        <Desktop>
          <ScreenHeader
            title={t('companyConfigurationForm.title') + accountResult?.companyName?.toUpperCase()}
            subtitle={t('companyConfigurationForm.subtitle')}
            right={
              <CloseButton onClick={() => history.goBack()}>
                <CloseIcon />
              </CloseButton>
            }
          />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            validationSchema={validationSchema}
            initialValues={initValues}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({
              values,
              setValues,
              dirty,
              setFieldValue,
              errors,
              submitCount,
              isValid,
              validateField,
            }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer>
                  <Section title={t('companyConfigurationForm.subtitle-companyConfiguration')}>
                    {accountResult.type === 'supportImplementation' && 
                      (<>
                      <Field name="branchCodeNetactica" label={t('companyConfigurationForm.branchCodeNetactica')}>
                        <Input id="branchCodeNetactica" placeholder="" />
                      </Field>
                      <Field name="businessUnitNetactica" label={t('companyConfigurationForm.businessUnitNetactica')}>
                        <Input id="businessUnitNetactica" placeholder="" />
                      </Field>
                      <Field name="countryCode" label={t('companyConfigurationForm.countryCode')}>
                        <Input id="countryCode" placeholder="" />
                      </Field>
                      <Field
                        name="companyDocumentNumberNetactica"
                        label={t('companyConfigurationForm.companyDocumentNumberNetactica')}
                      >
                        <Input id="companyDocumentNumberNetactica" placeholder="" />
                      </Field>
                      <Field
                        name="profileDocumentNumberNetactica"
                        label={t('companyConfigurationForm.profileDocumentNumberNetactica')}
                      >
                        <Input id="profileDocumentNumberNetactica" placeholder="" />
                      </Field>
                      <Field
                        name="passportDocumentNumberNetactica"
                        label={t('companyConfigurationForm.passportDocumentNumberNetactica')}
                      >
                        <Input id="passportDocumentNumberNetactica" placeholder="" />
                      </Field>
                      <Field name="apiBaseUrl" label={t('companyConfigurationForm.apiBaseUrl')}>
                        <Input id="apiBaseUrl" placeholder="" />
                      </Field>
                      <Field name="tokenexUrls" label={t('companyConfigurationForm.tokenexUrls')}>
                        <Input id="tokenexUrls" placeholder="" />
                      </Field>                    
                      </>)
                    }
                  </Section>
                  
                  <Section title={t('companyConfigurationForm.subtitle-help-support')}>
                    {accountResult.type === 'supportImplementation' && 
                      (<>
                        <Field name="whatsapp" label={t('companyConfigurationForm.whatsapp')}>
                          <Input id="whatsapp" placeholder="" />
                        </Field>
                        <Field name="script3CX" label={t('companyConfigurationForm.script3CX')}>
                          <Input id="script3CX" placeholder="" />
                        </Field>
                        <Field name="email" label={t('companyConfigurationForm.email')}>
                          <Input id="email" placeholder="" />
                        </Field>
                        <Field name="phone" label={t('companyConfigurationForm.phone')}>
                          <Input id="phone" placeholder="" />
                        </Field>
                        <Field name="application" label={t('companyConfigurationForm.applications-title')}>
                          <Input id="application" placeholder={t('companyConfigurationForm.applications-placeholder')} replaceFontSizePlaceholder={true}/>
                        </Field>
                        <Field name="applicationUrl" style={{ paddingTop: !isMobile ? '44px' : undefined }}>
                          <Input id="applicationUrl" placeholder={t('companyConfigurationForm.applications-url')} />
                        </Field>                        
                        <Field name="documentation" label={t('companyConfigurationForm.documentation-title')}>
                          <Input id="documentation" placeholder={t('companyConfigurationForm.documentation-placeholder')} replaceFontSizePlaceholder={true} />
                        </Field>
                        <Field name="documentationUrl" style={{ paddingTop: !isMobile ? '44px' : undefined }}>
                          <Input id="documentationUrl" placeholder={t('companyConfigurationForm.documentation-url')} />
                        </Field>
                        
                      </>)
                    }
                  </Section>
                  
                  {accountResult.type === 'supportImplementation' && 
                    (<Section title={t('companyConfigurationForm.subtitle-currency')}>
                      <CustomSelect
                        name="currencyCode"
                        error={isValidCurrencyCode()}
                        onChange={(e) => {
                          setFieldValue('currencyCode', e.value); // Atualiza o valor no Formik
                          setCurrencyCodeSelected(e.value);
                        }}
                        label={t('companyConfigurationForm.currencyCode')}
                        placeHolder=""
                        selectRef={currencyCodeRef}
                        value={currencyCodeSelected}
                      >
                        {({ ...selectProps }: CustomSelectRenderProps) => (
                          <OptionsItems {...selectProps} selectRef={currencyCodeRef} currencyCodes={currencyCodeList} />
                        )}
                      </CustomSelect>  
                      
                      <CustomSelect
                        name="alternativeCurrencyCode"
                        onChange={(e) => {
                          setFieldValue('alternativeCurrencyCode', e.value); // Atualiza o valor no Formik
                          setAlternativeCurrencyCodeSelected(e.value);
                        }}
                        label={t('companyConfigurationForm.alternativeCurrencyCode')}
                        placeHolder=""
                        selectRef={alternativeCurrencyCodeRef}
                        value={alternativeCurrencyCodeSelected}
                      >
                        {({ ...selectProps }: CustomSelectRenderProps) => (
                          <OptionsItems {...selectProps} selectRef={alternativeCurrencyCodeRef} currencyCodes={currencyCodeList} />
                        )}
                      </CustomSelect> 
                    </Section>)}

                    {accountResult.type === 'supportImplementation' && 
                      (<Section hide={hideLogoAndColor()} title={t('companyConfigurationForm.subtitle-colors')}>
                        <Field
                          name="ownerCompanyName"
                          label={t('companyConfigurationForm.ownerCompanyName')}
                        >
                          <Input id="ownerCompanyName" placeholder="" />
                        </Field>
                        
                        <LogoResellerPhoto
                          saveProfileImage={(e) => {
                            setFieldValue('logoResellerChanged', e.formData); 
                            handleChangePhotoLogoReseller(e);
                          }}
                          imageSrc={srcLogoReseller || ''}
                          isEdit
                        />

                        <Field name="companyName" label={t('companyConfigurationForm.companyName')}>
                          <Input id="companyName" placeholder="" />
                        </Field>
                        
                        <LogoCompanyPhoto
                          saveProfileImage={(e) => {
                            setFieldValue('logoCompanyChanged', e.formData); 
                            handleChangePhotoLogoCompany(e);
                          }}
                          imageSrc={srcLogoCompany || ''}
                          isEdit
                        />

                        <FaviconPhotoInfo
                          saveProfileImage={(e) => {
                            setFieldValue('faviconChanged', e.formData);
                            handleChangePhoto(e);
                          }}
                          imageSrc={srcFavicon || ''}
                          isEdit
                          name={myConfigurationCompany?.companyName || ''}
                          email={myConfigurationCompany?.email || ''}
                        />

                        <Field name="pageTitle" label={t('companyConfigurationForm.pageTitle')}>
                          <Input id="pageTitle" placeholder="" />
                        </Field>

                        <Field
                          name="primaryBackgroundColor"
                          label={t('companyConfigurationForm.primaryBackgroundColor')}
                        >
                          <Input id="primaryBackgroundColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                        <Field name="primaryColor" label={t('companyConfigurationForm.primaryColor')}>
                          <Input id="primaryColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                        <Field
                          name="secondaryBackgroundColor"
                          label={t('companyConfigurationForm.secondaryBackgroundColor')}
                        >
                          <Input id="secondaryBackgroundColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                        <Field name="secondaryColor" label={t('companyConfigurationForm.secondaryColor')}>
                          <Input id="secondaryColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                        <Field
                          name="tertiaryBackgroundColor"
                          label={t('companyConfigurationForm.tertiaryBackgroundColor')}
                        >
                          <Input id="tertiaryBackgroundColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                        <Field name="tertiaryColor" label={t('companyConfigurationForm.tertiaryColor')}>
                          <Input id="tertiaryColor" type="color" placeholder="#FFFFFF" />
                        </Field>
                      </Section>)}

                  {accountResult.type === 'supportImplementation' &&
                    (<Section hide={hideLogoAndColor()} title={t('companyConfigurationForm.subtitle-emails')}>
                      <Field
                        name="emailFooterBackground"
                        label={t('companyConfigurationForm.emailFooterBackground')}
                      >
                        <Input id="emailFooterBackground" type="color" placeholder="#FFFFFF" value="#FFDD00" />
                      </Field>
                      <Field name="emailFooterColor" label={t('companyConfigurationForm.emailFooterColor')}>
                        <Input id="emailFooterColor" type="color" placeholder="#FFFFFF" value="#FFDD00" />
                      </Field>
                      <Field name="emailBodyTextColor" label={t('companyConfigurationForm.emailBodyTextColor')}>
                        <Input id="emailBodyTextColor" type="color" placeholder="#FFFFFF" value="#FFDD00" />
                      </Field>
                      <Field name="emailButtonColor" label={t('companyConfigurationForm.emailButtonColor')}>
                        <Input id="emailButtonColor" type="color" placeholder="#FFFFFF" value="#FFDD00" />
                      </Field>
                    </Section>)}

                  <Section title={t('companyConfigurationForm.subtitle-email-data')}>
                    <Field name="emailDisplayEmail" label={t('companyConfigurationForm.emailDisplayEmail')}>
                      <Input id="emailDisplayEmail" placeholder="" />
                    </Field>
                    <Field name="emailDisplayName" label={t('companyConfigurationForm.emailDisplayName')}>
                      <Input id="emailDisplayName" placeholder="" />
                    </Field>
                    <Field name="emailFooter" label={t('companyConfigurationForm.emailFooter')}>
                      <Input id="emailFooter" placeholder="" />
                    </Field>
                  </Section>

                  <Section title={t('companyConfigurationForm.subtitle-vouchers')} noGap={true} joinContent={true}>
                    <Field
                      name="sendCopyVoucher"
                      label={t('companyConfigurationForm.sendCopyVoucher')}
                    >
                      <Input id="sendCopyVoucher" placeholder="" />
                    </Field>
                    <ToggleCard
                      title={t('companyConfigurationForm.notSendVoucherOthersFlightPassenger')}
                      message={''}
                      value={values.notSendVoucherOthersFlightPassenger ? true : false}
                      onToggle={(_, value) =>
                        setFieldValue('notSendVoucherOthersFlightPassenger', value ? true : false)
                      }
                      hide={false}
                    />
                  </Section>

                  {accountResult.type === 'supportImplementation' &&
                    (<Section title={t('companyConfigurationForm.subtitle-twilio')}>
                      <Field
                        name="twilioWhatsappNumberFrom"
                        label={t('companyConfigurationForm.twilioWhatsappNumberFrom')}
                      >
                        <Input id="twilioWhatsappNumberFrom" placeholder="" />
                      </Field>
                    </Section>
                  )}

                  <Section title={t('companyConfigurationForm.subtitle-personalization')}>
                    <ToggleCard
                      title={t('companyConfigurationForm.airFlow')}
                      message={t('companyConfigurationForm.hideAirFlow')}
                      value={!values.menuView.hideAirFlow ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideAirFlow', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.hotelFlow')}
                      message={t('companyConfigurationForm.hideHotelFlow')}
                      value={!values.menuView.hideHotelFlow ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideHotelFlow', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.vehicleFlow')}
                      message={t('companyConfigurationForm.hideVehicleFlow')}
                      value={!values.menuView.hideVehicleFlow ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideVehicleFlow', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.expenses')}
                      message={t('companyConfigurationForm.hideExpenses')}
                      value={!values.menuView.hideExpenses ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideExpenses', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.whatsapp2')}
                      message={t('companyConfigurationForm.hideWhatsapp')}
                      value={!values.menuView.hideWhatsapp ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideWhatsapp', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.costCenter')}
                      message={t('companyConfigurationForm.hideCostCenter')}
                      value={!values.menuView.hideCostCenter ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideCostCenter', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.reports')}
                      message={t('companyConfigurationForm.hideReports')}
                      value={!values.menuView.hideReports ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideReports', !value ? true : false)}
                      hide={false}
                    />
                    <ToggleCard
                      title={t('companyConfigurationForm.travelReason')}
                      message={t('companyConfigurationForm.hideTravelReason')}
                      value={!values.menuView.hideTravelReason ? true : false}
                      onToggle={(_, value) => setFieldValue('menuView.hideTravelReason', !value ? true : false)}
                      hide={false}
                    />
                    {accountResult.type === 'supportImplementation' &&
                      <>
                        <ToggleCard
                          title={t('companyConfigurationForm.nationalAirBySector')}
                          message={t('companyConfigurationForm.nationalAirBySector')}
                          value={values.nationalAirBySector ? true : false}
                          onToggle={(_, value) => setFieldValue('nationalAirBySector', value ? true : false)}
                          hide={false}
                        />
                        <ToggleCard
                          title={t('companyConfigurationForm.internationalAirBySector')}
                          message={t('companyConfigurationForm.internationalAirBySector')}
                          value={values.internationalAirBySector ? true : false}
                          onToggle={(_, value) => setFieldValue('internationalAirBySector', value ? true : false)}
                          hide={false}
                        />
                      </>
                    }
                  </Section>
                  
                  {accountResult.type === 'supportImplementation' && 
                    (<>
                      <Section title={t('companyConfigurationForm.subtitle-sso')}>
                        <FieldArray name="loginSso.sso">
                          {({ push, remove }) => (
                            <div>
                              <ToggleCard
                                title={t('companyConfigurationForm.nsLogin')}
                                message={t('companyConfigurationForm.hideNsLogin')}
                                value={values.loginSso.nsLogin ? true : false}
                                onToggle={(_, value) => setFieldValue('loginSso.nsLogin', value ? true : false)}
                                hide={false}
                              />
                              <br />
                              <ToggleCard
                                title={t('companyConfigurationForm.isSsoCorporate')}
                                message={t('companyConfigurationForm.isSsoCorporate')}
                                value={values.loginSso.isSsoCorporate ? true : false}
                                onToggle={(_, value) => setFieldValue('loginSso.isSsoCorporate', value ? true : false)}
                                hide={false}
                              />
                              <br />
                              {values.loginSso.sso.map((_, index) => (
                                <div key={index} style={{ margin: '20px 0px' }}>
                                  SSO {index + 1}
                                  <AddAndRemoveSector onClick={() => remove(index)}>- Eliminar SSO</AddAndRemoveSector>
                                  <Field name={`loginSso.sso[${index}].url`} label={t('companyConfigurationForm.url')}>
                                    <Input id={`loginSso.sso[${index}].url`} placeholder="" />
                                  </Field>
                                  <Field
                                    name={`loginSso.sso[${index}].textButton`}
                                    label={t('companyConfigurationForm.textButton')}
                                  >
                                    <Input id={`loginSso.sso[${index}].textButton`} placeholder="" />
                                  </Field>
                                  <Field
                                    name={`loginSso.sso[${index}].backgroundColor`}
                                    label={`${t('companyConfigurationForm.backgroundColor')}: ${
                                      values.loginSso.sso[index].backgroundColor
                                    }`}
                                  >
                                    <Input
                                      id={`loginSso.sso[${index}].backgroundColor`}
                                      type="color"
                                      placeholder="#FFFFFF"
                                      value="#FFDD00"
                                    />
                                  </Field>
                                  <Field
                                    name={`loginSso.sso[${index}].textColor`}
                                    label={`${t('companyConfigurationForm.textColor')}: ${
                                      values.loginSso.sso[index].textColor
                                    }`}
                                  >
                                    <Input
                                      id={`loginSso.sso[${index}].textColor`}
                                      type="color"
                                      placeholder="#FFFFFF"
                                      value="#FFDD00"
                                    />
                                  </Field>
                                  <Field name={`loginSso.sso[${index}].logo`} label={t('companyConfigurationForm.logo')}>
                                    <Input id={`loginSso.sso[${index}].logo`} placeholder="" />
                                  </Field>
                                </div>
                              ))}
                              <AddAndRemoveSector
                                onClick={() =>
                                  push({
                                    url: '',
                                    textButton: '',
                                    backgroundColor: '',
                                    textColor: '',
                                    logo: '',
                                  })
                                }
                              >
                                + Adicionar SSO
                              </AddAndRemoveSector>
                            </div>
                          )}
                        </FieldArray>
                      </Section>                      
                    </>
                    )}

                  <>
                    <Section title={t('branchCompany.form.payment.title')}>
                      <ToggleCard
                        title={t('branchCompany.form.payment.lineOfCredit')}
                        value={values.lineOfCreditAvailable}
                        onToggle={(_, value) => setFieldValue('lineOfCreditAvailable', value ? true : false)}
                        hide={false}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCard')}
                        value={!values.lineOfCreditAvailable}
                        onToggle={(_, value) => setFieldValue('lineOfCreditAvailable', value ? false : true)}
                        hide={false}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCardByCompany')}
                        value={!values.creditCardByUser}
                        onToggle={(_, value) => setFieldValue('creditCardByUser', value ? false : true)}
                        hide={values.lineOfCreditAvailable}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCardByUser')}
                        value={values.creditCardByUser}
                        onToggle={(_, value) => setFieldValue('creditCardByUser', value ? true : false)}
                        hide={values.lineOfCreditAvailable}
                      />
                      <br /><br />
                    </Section>

                    {accountResult.companyId && <PaymentExceptions companyId={accountResult.companyId} lineOfCreditAvailable={values.lineOfCreditAvailable} />}
                  </>
                  <Mobile>
                    <Section></Section>
                    <Section></Section>
                  </Mobile>

                  <SearchButtonContainer>
                    <SearchButton
                      type="submit"
                      disabled={!dirty || !isValid || !currencyCodeSelected}
                      value={t('companyConfigurationForm.others.saveButton')}
                    />
                  </SearchButtonContainer>
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default CompanyConfigurationUpdate;
function setFieldValue(arg0: string, value: any) {
  throw new Error('Function not implemented.');
}

